import React from 'react';

import { cx } from '@travel/utils';

import styles from './planPaymentRestriction.module.scss';

function PlanPaymentRestriction(props: {
  className?: string;
  titleClassName?: string;
  managementName: string;
  text: string;
  Icon: React.ReactNode;
}) {
  const { Icon } = props;

  return (
    <div className={cx(styles.wrapper, props.className)}>
      {Icon}
      <span className={cx(styles.titleText, props.titleClassName)}>{props.text}</span>
    </div>
  );
}

export default PlanPaymentRestriction;
